import React from 'react';
import DirectSales from 'Modules/directSales/routes/DirectSales';

export const directSalesPath = '/journey/direct-sales';

export const routes = [{ path: directSalesPath, element: <DirectSales /> }];
